import { Capacitor } from "@capacitor/core";
import openExternalUrl from "Helpers/openExternalUrl";

const LexusExternalLinkButton: React.FC<React.AnchorHTMLAttributes<HTMLAnchorElement>> = props => {
    const handleClick: React.MouseEventHandler<HTMLAnchorElement> = event => {
        if (Capacitor.isNativePlatform() && props.href) {
            event.preventDefault();
            void openExternalUrl(props.href);
        }
    };
    return (
        <a {...props} href={props.href} onClick={handleClick}>
            {props.children}
        </a>
    );
};

export default LexusExternalLinkButton;
